import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Link from '@mui/material/Link'
import { Trans, useTranslation } from 'react-i18next'

const PoliciesContent = () => {
  const { t } = useTranslation('policies')

  return (
    <>
      <Typography
        variant='h5' sx={{
        fontWeight: 'bold'
      }}
      >
        {t('cancellation.title')}
      </Typography>
      <Typography variant='body1'>
        {t('cancellation.p1')}<br /><br />
        {t('cancellation.p2')}
        {t('cancellation.p3')}<br /><br />
        {t('cancellation.p4')}<br /><br />
        {t('cancellation.p5')}<br /><br />
        {t('cancellation.p6')}
      </Typography>
      <Divider sx={{ my: 4 }} />
      <Typography
        variant='h5'
        sx={{
          fontWeight: 'bold',
          mt: 2
        }}
      >
        {t('personalData.title')}
      </Typography>
      <Typography variant='body1'>
        {t('personalData.p1')}
      </Typography>

      <Typography variant='body1'><br /><br />
        <Trans
          i18nKey='personalData.p2'
          components={{
            1: <Link
              href='https://my.raceresult.com'
              target='_blank'
              rel='noopener noreferrer'
              underline='hover'
               />
          }}
        >
          MyRaceResult
        </Trans>
      </Typography><br /><br />

      <Typography variant='body1'>
        <Trans
          i18nKey='personalData.p3'
          components={{
            1: <Link
              href='https://www.raceresult.com/en-ae/company/dataprivacy'
              target='_blank'
              rel='noopener noreferrer'
              underline='hover'
               />
          }}
        >
          MyRaceResult’s Privacy Policy
        </Trans>
      </Typography><br /><br />

      <Typography variant='body1'>
        <Trans
          i18nKey='personalData.p4'
          components={{
            1: <strong />,
            2: <strong />
          }}
        >
          WhatsApp, Instagram
        </Trans>
      </Typography>
    </>
  )
}

export const policies = <PoliciesContent />
